import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from '../../../../core/modules/common/components/Button';
import Modal from '../../../../core/modules/common/components/Modal';
import themeStyles from '../../../../materialUiTheme';
import AllSelector from '../../../common/components/AllSelector';
import OnlySelectedFilterCheckbox from '../../../common/components/OnlySelectedFilterCheckbox';
import Icons from '../../../../core/modules/common/components/Icons';
import { saveUserProductSelectionRequestActionCreator } from '../../../user/redux/actions/UserActions';
import ProgressButtons from '../../common/components/ProgressButtons';
import {
  deSelectAllCategories,
  fetchMailClasses,
  selectAllCategories,
  showOnlySelectedMailClasses,
} from '../redux/actions/ProductActions';
import {
  getCheckedMailClasses,
  getIsShowOnlySelectedMailClasses,
  getMailClassesIsLoading,
} from '../redux/selectors/MailClassesSelectors';
import MailCategories from './MailCategories';
import MailCategorySelectorContainer from './MailCategorySelectorContainer';
import MailCategoryItemSelectorContainer from './MailCategoryItemSelectorContainer';
import ProductSelectionHeaderBarContainer from './ProductSelectionHeaderBarContainer';
import SaveProductSelectionFormContainer from './SaveProductSelectionFormContainer';
import * as ProductTypes from '../../../common/redux/actions/types/ProductTypes';
import sc from '../../../common/redux/actions/types/SelectionCriteriaTypes';
// eslint-disable-next-line import/no-cycle
import scDefinitions from '../../../common/config/SelectionCriteriaDefinitions';
import ReportDefinitions from '../../../common/config/ReportDefinitions';
import { createProductPresetSelectionsOnSave } from "../../../react-table/helpers/utils";

const SC_CODE = sc.SC030;

export class ProductSelectorWizardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
  }

  componentDidMount() {
    if (!this.props.isLoading) {
      this.props.fetchMailClasses(this.props.checkedMailClasses);
    }
  }

  selectAll = () => {
    this.props.selectAllCategories();
  };

  deSelectAll = () => {
    this.props.deSelectAllCategories();
  };

  saveSelection = (values) => {
    const selections = createProductPresetSelectionsOnSave(this.props.productSelector.categories, this.props.productSelector.mailClassNodes);
    this.props.saveUserProductSelectionRequestActionCreator(
      values.name,
      selections,
    );

    this.toggleModal();
  };

  toggleModal = () => {
    this.setState({
      // eslint-disable-next-line react/no-access-state-in-setstate
      showModal: !this.state.showModal,
    });
  };

  render() {
    const reportId = this.props.match.params.reportName;
    const selectionCriteria = ReportDefinitions[reportId].selectionCriteria.items;
    const nextSelectionCriteriaRouteName = (
      scDefinitions[selectionCriteria[selectionCriteria.indexOf(SC_CODE) + 1]] || {}
    ).routeName;
    // eslint-disable-next-line react/prop-types
    const expandDisabled = this.props.children.report.productTypes === ProductTypes.MAIL_CLASS || this.props.children.report.productTypes === ProductTypes.MAIL_CATEGORY;
    return (
      <div className="product-selection-wrapper">
        <div className="product-selection">
          <div className="product-selection-header">
            <ProductSelectionHeaderBarContainer categoryOnlySelection={this.props.children.report.productTypes === ProductTypes.MAIL_CATEGORY} />
          </div>

          {
            (this.props.children.report.productTypes === ProductTypes.MAIL_SUBCLASS || this.props.children.report.productTypes === ProductTypes.MAIL_CLASS) &&
            <div className="product-selection-content">
              <div className="product-tree">
                <MailCategorySelectorContainer
                  mailCategory={MailCategories.a.code}
                  description={MailCategories.a.description}
                  expandDisabled={expandDisabled}
                />
              </div>

              <div className="product-tree">
                <MailCategorySelectorContainer
                  mailCategory={MailCategories.b.code}
                  description={MailCategories.b.description}
                  expandDisabled={expandDisabled}
                />
              </div>

              <div className="product-tree">
                <MailCategorySelectorContainer
                  mailCategory={MailCategories.c.code}
                  description={MailCategories.c.description}
                  expandDisabled={expandDisabled}
                />
              </div>

              <div className="product-tree">
                <MailCategorySelectorContainer
                  mailCategory={MailCategories.d.code}
                  description={MailCategories.d.description}
                  expandDisabled={expandDisabled}
                />
              </div>
            </div>
          }

          {
            this.props.children.report.productTypes === ProductTypes.MAIL_CATEGORY &&
            <div className="product-selection-content">
              <div className="product-tree">
                <div className="selector-header">
                  <h3 className="selector-title">Mail Categories</h3>
                </div>

                <MailCategoryItemSelectorContainer
                  mailCategory={MailCategories.a.code}
                  description={MailCategories.a.description}
                  expandDisabled
                  showOnlySelected={this.props.isShowOnlySelected}
                />
                <MailCategoryItemSelectorContainer
                  mailCategory={MailCategories.b.code}
                  description={MailCategories.b.description}
                  expandDisabled
                  showOnlySelected={this.props.isShowOnlySelected}
                />
                <MailCategoryItemSelectorContainer
                  mailCategory={MailCategories.c.code}
                  description={MailCategories.c.description}
                  expandDisabled
                  showOnlySelected={this.props.isShowOnlySelected}
                />
                <MailCategoryItemSelectorContainer
                  mailCategory={MailCategories.d.code}
                  description={MailCategories.d.description}
                  expandDisabled
                  showOnlySelected={this.props.isShowOnlySelected}
                />
              </div>
            </div>
          }

          <div className="product-selection-footer">
            <div className="product-selection-footer__action left">
              <Button
                {...themeStyles.operatorSelectors.button}
                text="app.save.selection.button.label"
                onClick={this.toggleModal}
                iconComponent={<Icons.DownloadIcon />}
              />
              {this.state.showModal && (
                <Modal
                  header={
                    <FormattedMessage
                      id="app.save.product.selection.form.title"
                      tagName="h3"
                    />
                  }
                  closeOnOutsideClick
                  onClose={this.toggleModal}
                >
                  <SaveProductSelectionFormContainer
                    onSubmit={this.saveSelection}
                    onCloseModal={this.toggleModal}
                    selections={this.props.productSelector.selections}
                    categories={this.props.productSelector.categories}
                  />
                </Modal>
              )}
            </div>
            <div className="product-selection-footer__action left">
              <OnlySelectedFilterCheckbox
                isShowOnlySelected={this.props.isShowOnlySelected}
                onShowOnlySelected={this.props.onShowOnlySelected}
              />
            </div>
            <div className="product-selection-footer__action left">
              <AllSelector
                onSelectAll={this.selectAll}
                onDeSelectAll={this.deSelectAll}
              />
            </div>
            <div className="product-selection-footer__action right">
              <div className="actions">
                <ProgressButtons
                  next={this.props.children.routes[nextSelectionCriteriaRouteName]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    checkedMailClasses: getCheckedMailClasses(state),
    isShowOnlySelected: getIsShowOnlySelectedMailClasses(state),
    isLoading: getMailClassesIsLoading(state),
    productSelector: state.productSelector,
  };
}

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchMailClasses,
  selectAllCategories,
  deSelectAllCategories,
  onShowOnlySelected: showOnlySelectedMailClasses,
  saveUserProductSelectionRequestActionCreator,
}, dispatch);

ProductSelectorWizardContainer.propTypes = {
  fetchMailClasses: PropTypes.func,
  selectAllCategories: PropTypes.func,
  deSelectAllCategories: PropTypes.func,
  isShowOnlySelected: PropTypes.bool,
  isLoading: PropTypes.bool,
  onShowOnlySelected: PropTypes.func,
  saveUserProductSelectionRequestActionCreator: PropTypes.func,
  productSelector: PropTypes.objectOf(PropTypes.shape),
  checkedMailClasses: PropTypes.arrayOf(PropTypes.string),
  routes: PropTypes.objectOf(PropTypes.shape).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      reportName: PropTypes.string,
    }),
  }),
};

export const ConnectedProductSelectorWizardContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductSelectorWizardContainer);

export default (ConnectedProductSelectorWizardContainer);
